import React, { useCallback, useState } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SerializedSocialPost } from '../promote/types';
import { socialPostTypeMessages } from './socialMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet per screen; each part of the screen uses its own slice of it */
import styles from './Social.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SocialPostThumbProps {
  post: Pick<SerializedSocialPost, 'thumbnailUrl' | 'type'>;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * The picture of a post. A post with no picture shows the striped box; a text post shows the
 * word "Text" in it. A picture that does not load (the platform link expired) shows the box too.
 */
const SocialPostThumbComponent: React.FC<SocialPostThumbProps> = ({ post, size = 'sm' }) => {
  const intl = useIntl();
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const url = post.thumbnailUrl;
  const onError = useCallback(() => setFailedUrl(url), [url]);
  const sizeClass = size === 'lg' ? styles.thumbLg : size === 'md' ? styles.thumbMd : undefined;

  if (url === null || url === failedUrl) {
    return (
      <span className={clsx(styles.thumb, sizeClass)} data-testid="social-post-thumb-empty">
        {post.type === 'text' && size !== 'sm' ? (
          <span className={styles.thumbWord}>{intl.formatMessage(socialPostTypeMessages.text)}</span>
        ) : null}
      </span>
    );
  }

  return <img className={clsx(styles.thumb, styles.thumbImage, sizeClass)} src={url} alt="" onError={onError} />;
};

export const SocialPostThumb = TypedMemo(SocialPostThumbComponent);
